import Restriction from "../restriction";
import meshRestrictionHelper from "../meshRestrictionHelper";
import { ResourceTypeEnum } from "../../training/base/training-literals";

class RestrictModel extends Restriction {
    constructor() {
        super({
            type: meshRestrictionHelper.RestrictedMeshTypeEnum.MODEL,
            allowedTypesToPopulate: [
                meshRestrictionHelper.RestrictedMeshTypeEnum.GROUP,
                meshRestrictionHelper.RestrictedMeshTypeEnum.TREE,
                meshRestrictionHelper.RestrictedMeshTypeEnum.VOLUME
            ]
        });
    }

    isValid(branchIds = []) {
        if (branchIds.length === 0) return true;

        let modelIds = [];
        branchIds.forEach(branchId => {
            modelIds.push(getModelIdFromBranchId(branchId));
        });

        let invalidModelIds = [];
        modelIds.forEach(modelId => {
            if (!super.isValid(modelId)) invalidModelIds.push(modelId);
        });

        if (invalidModelIds.length > 0) {
            console.error('Restricted model found: ' + invalidModelIds);
        }

        return invalidModelIds.length === 0;
    }

    getPopulatedDataByType(models, applyTo, mode = meshRestrictionHelper.RestrictionMode.ALLOW_ALL) {
        const currentTraining = TrainingTreeController._trainingFeature.getActiveTraining();
        const resources = currentTraining.resources;
        let modelIds = models.map(model => resources[model.id]?.resourceId || (resources[model.id]?.type === ResourceTypeEnum.HELPER_OBJECT && resources[model.id]?.id));

        let data = [];
        if (mode === meshRestrictionHelper.RestrictionMode.DENY_ALL) modelIds = modelManager.getAllModelsId();
        if (applyTo === this.type) data = modelIds;

        modelIds.forEach(modelId => {
            if (this.allowedTypesToPopulate.includes(applyTo)) {
                data.push(...getDataBasedOnAppliedType(applyTo, modelId));
            }
        });

        return data;

        function getDataBasedOnAppliedType(type, modelId) {
            let groups;
            switch (type) {
                case meshRestrictionHelper.RestrictedMeshTypeEnum.VOLUME:
                    return modelManager.getBranchIds(modelId);
                case meshRestrictionHelper.RestrictedMeshTypeEnum.GROUP:
                    groups = GroupData.getGroupListByModelId(modelId);
                    return groups.map(group => group.name);
                case meshRestrictionHelper.RestrictedMeshTypeEnum.TREE:
                    return MeshHierarchyViewFeatureData.getAllBranchIds(modelId);
                default:
                    return [];
            }
        }
    }
}

export default RestrictModel;
